import request from '../utils/request'

// 用户登录

export function login (data) {
  return request.post(`/user/login/`, data)
}

// 用户注册

export function reg (data) {
  return request.post(`/user/reg/`, data)
}

// 发送验证码

export function sendsms (data) {
  return request.post(`/user/sendsms/`, data)
}

// 忘记密码

export function changepwd (data) {
  return request.post(`/user/changepwd/`, data)
}

// 服务查询

export function getService (id) {
  return request.get(`/service/${id}/info/`)
}

// // 设备查询

// export function getServicesinfo (id, data) {
//   return request.post(`/service/${id}/info/`, data)
// }

// 服务下单

export function postService (id, data) {
  return request.post(`/service/${id}/make_order/`, data)
}

// 订单列表

export function getOrder (data) {
  return request.post('/order/getlist/', data)
}

// 取消订单

export function cancelOrder (id) {
  return request.post(`/order/${id}/cancel/`)
}

// 查询订单

export function getInfo (id, data) {
  return request.post(`order/${id}/info/`, data)
}

// 订单修改

export function changeService (id, data) {
  return request.post(`/order/${id}/change/`, data)
}

// 订单支付

export function pay (id, data) {
  return request.post(`/order/${id}/pay/`, data)
}



// WEBPACK FOOTER //
// ./src/api/index.js